import { render, staticRenderFns } from "./DonateChart.vue?vue&type=template&id=15776987&scoped=true&"
import script from "./DonateChart.vue?vue&type=script&lang=js&"
export * from "./DonateChart.vue?vue&type=script&lang=js&"
import style0 from "./DonateChart.vue?vue&type=style&index=0&id=15776987&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15776987",
  null
  
)

export default component.exports